import { sendTrack } from './utilities/track';

const megaMenuEl = document.querySelector('#mega-menu-primary');
const isMobile = () => globalThis.matchMedia('(max-width: 991.98px)').matches;

let mobileMenuIsOpen = false;
let desktopHidden = false;

document.addEventListener('DOMContentLoaded', init);
globalThis.addEventListener('resize', handleResize);

function init() {
  if (!megaMenuEl || !globalThis.jQuery) {
    return;
  }

  mobileMegaMenuState();
  expandMegaSubMenu();
}

function handleResize() {
  expandMegaSubMenu();
}

function mobileMegaMenuState() {
  if (!megaMenuEl || !globalThis.jQuery) {
    return;
  }

  const $menu = globalThis.jQuery(megaMenuEl);

  $menu.on('mmm:showMobileMenu', () => {
    mobileMenuIsOpen = true;

    document.body.classList.add('blur');

    expandMegaSubMenu(true);

    sendTrack('Mobile Menu Opened', {
      path: globalThis.location.pathname,
      url: globalThis.location.href,
      title: document.title
    });
  });

  $menu.on('mmm:hideMobileMenu', () => {
    if (!document.querySelector('.collapse.show[data-collapse="blur"]')) {
      document.body.classList.remove('blur');
    }

    if (!mobileMenuIsOpen) {
      return;
    }

    mobileMenuIsOpen = false;

    sendTrack('Mobile Menu Closed', {
      path: globalThis.location.pathname,
      url: globalThis.location.href,
      title: document.title
    });
  });
}

function expandMegaSubMenu(force = false) {
  if (!megaMenuEl || !globalThis.jQuery) {
    return;
  }

  const $ = globalThis.jQuery;

  const $menu = $('#mega-menu-primary');
  const maxMega = $menu.data('maxmegamenu');

  if (!maxMega) {
    return;
  }

  if (isMobile() || force) {
    setTimeout(() => {
      const $panelToShow = $('#mega-menu-item-1150 > a.mega-menu-link');

      if ($panelToShow.length) {
        maxMega.showPanel($panelToShow);
      }
    }, 50);

    desktopHidden = false;
    return;
  }

  if (!desktopHidden) {
    setTimeout(() => {
      maxMega.hideAllPanels();
    }, 50);

    desktopHidden = true;
  }
}
